import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// TODO Comment / Ist es nötig?
export const RouteObserver = () => {
    const location = useLocation();

    useEffect(() => {
        // Store return route when entering settings -> do not return to settings, but last page before entering settings
        if (!location.pathname.startsWith("/settings") && location.pathname !== "/") {
            localStorage.setItem("settingsReturnRoute", location.pathname);
        }
    }, [location]);

    return null;
};
